import logo from './logo.svg';
import './App.css';
import Navigationbar from './Navigationbar';
import Upload from './Upload';
import Pages from './Pages';

function App() {
  return (
    <>
      <Navigationbar></Navigationbar>
      <Pages></Pages>
      {/* <Upload></Upload> */}
      </>
  );
}

export default App;
